import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const hubspotApi = createApi({
  reducerPath: 'hubspotApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL + '/hubspot',
    prepareHeaders: (headers, { getState }) => {
      // Obtener la URL actual
      const url = window.location.href;

      // Crear un objeto URLSearchParams con los parámetros de la URL
      const queryParams = new URLSearchParams(url.split('?')[1]);

      // Convertir los parámetros en un objeto
      const paramsObj = {};
      queryParams.forEach((value, key) => {
          paramsObj[key] = value;
      });

      // If we have a token set in state, let's assume that we should be passing it.
      headers.set('authorization', `Bearer ${paramsObj["token"]}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getProperties: builder.mutation({
      query({body, object}) {
        return {
          url: `/properties/${object}`,
          method: 'POST',
          body,
        };
      },
    }),

  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPropertiesMutation,
} = hubspotApi;
